import { render, staticRenderFns } from "./BCXCard.vue?vue&type=template&id=4d9e852a&scoped=true"
import script from "./BCXCard.vue?vue&type=script&lang=ts"
export * from "./BCXCard.vue?vue&type=script&lang=ts"
import style0 from "./BCXCard.vue?vue&type=style&index=0&id=4d9e852a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9e852a",
  null
  
)

export default component.exports